'use strict';

let _ = require('lodash');
let BaseFacetView = require('./BaseFacetView');
// let Signal = require('signals').Signal;

class MultipleFacetView extends BaseFacetView {

  constructor(config, $el, margins) {
    super(config, $el, margins);

    this._title = 'Multiple Selection Chart';
    this._selectedMap = {};
  }

  clear() {
    this._selectedMap = {};
    super.clear();
  }

  // HANDLERS

  _onMouseOver(d) {
    if (this._mouseDown) {
      this._select(d, this._selectionMode);
      this._drawSelection(d, 'down');
      if (this._liveUpdate) this._onExtentSelected();
    } else {
      this._drawSelection(d, 'over');
    }
  }

  _onMouseOut(d) {
    // var isSelected = this._isSelected(d);
    this._drawSelection(d, 'up');
  }

  _onMouseDown(d) {
    this._mouseDown = true;
    this._selectionMode = !this._isSelected(d);
    if (!d3.event.ctrlKey) this._selectedMap = {};
    this._drawChart();
    this._onMouseOver(d);
    this._selectionMode = true;
  }

  _onMouseUp() {
    this._mouseDown = false;
    if (!this._liveUpdate) this._onExtentSelected();
  }

  _updateSelection(extent) {
    if (_.isEqual(extent, _.keys(this._selectedMap))) return;
    if (!extent || !extent.length) this._selectedMap = {};
    else this._selectedMap = _.zipObject(extent, _.map(extent, function() {
      return true;
    }));
  }

}

module.exports = MultipleFacetView;



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/sidebar/archive/facets/MultipleFacetView.es6
 **/